export default __webpack_public_path__ + "static/media/Hair_10_M_C3.48156336.svg";